import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import {
  ToolbarNotificationsDropdownComponent
} from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../shared/services/auth.service';
import { GlobalService } from '../../../../shared/services/global.service';
import { SocketService } from '../../../../shared/services/socket.service';
import { Notification } from './interfaces/notification.interface';
import { ChimeService } from '../../../../shared/services/chime.service';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule,
    FormsModule
  ],
  providers: [AuthService, GlobalService]
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('originRef', { static: true, read: ElementRef }) originRef?: ElementRef;

  dropdownOpen: boolean = false;
  notifications: Notification[] = [];
  unreadNotification: number;

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private chimeService: ChimeService,
    private socketService: SocketService
  ) {
    this.unreadNotification = 0;
   //  this.setupSubscription();
  }

  ngOnInit(): void {
    /*this.socketService.onUserNotification().subscribe((data) => {
      const notification: Notification = {
        id: Date.now(),
        label: data || 'New Notification',
        icon: 'mat:notifications',
        colorClass: 'text-primary',
        datetime: this.getCurrentLocalDateAndTime(),
        read: false
      };
      this.notifications.unshift(notification);
      this.unreadNotification++;
      this.chimeService.playChime();
      this.cd.markForCheck();
    });

    this.socketService.onUserTypeNotification().subscribe((data) => {
      const notification: Notification = {
        id: Date.now(),
        label: data || 'New Notification',
        icon: 'mat:notifications',
        colorClass: 'text-primary',
        datetime: this.getCurrentLocalDateAndTime(),
        read: false
      };
      this.notifications.unshift(notification);
      this.unreadNotification++;
      this.chimeService.playChime();
      this.cd.markForCheck();
    });*/
  }

  /*private setupSubscription(): void {
    this.chimeService.mySubject$.subscribe((value) => {
      if (value === true) {
        this.notifications = [];
        this.unreadNotification = this.notifications.length;
      }
    });
  }*/

  getCurrentLocalDateAndTime(): string {
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();
    return `${date} ${time}`;
  }

  showPopover(): void {
    this.dropdownOpen = true;
    this.unreadNotification = 0;
    this.cd.markForCheck();

    if (!this.originRef) {
      throw new Error('originRef undefined!');
    }

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ],
      data: {
        notifications: this.notifications
      }
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.unreadNotification = 0;
      this.cd.markForCheck();
    });
  }
}
